import { Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { EmailSummaryItem, RowSummaryItem } from '../';
import testFlag from '../../../assets/images/icon-testFlag.png';
import { DistributionListSummaryItemContainer } from '../../../containers/summary-item/DistributionListSummaryItem';
import { AudienceSummaryItemType, ISummaryItem } from '../../../models';
import { CustomBanner } from '../CustomBanner';

export interface ISurveyAudienceSummaryItemProps {
	surveyId: number;
	audienceId: number;
	summaryItems: ISummaryItem[];
}

const BannerDiv = styled.div`
	display: inline-block;
`;

export class SurveyAudienceSummaryItem extends React.Component<ISurveyAudienceSummaryItemProps> {
	constructor(props: ISurveyAudienceSummaryItemProps) {
		super(props);

		this.getSummaryItem = this.getSummaryItem.bind(this);
	}

	public render() {
		return this.props.summaryItems.map(this.getSummaryItem);
	}

	public getSummaryItem(summaryItem: ISummaryItem, key: any) {
		switch (summaryItem.propertyName) {
			case AudienceSummaryItemType.AudienceName:
			case AudienceSummaryItemType.OpenCloseDates:
			case AudienceSummaryItemType.DistributionType:
			case AudienceSummaryItemType.SurveyLink:
			case AudienceSummaryItemType.SsoAttribute:
				return <RowSummaryItem key={key} {...summaryItem} />;
			case AudienceSummaryItemType.DistributionFile:
			case AudienceSummaryItemType.DistributionHierarchy:
				return <DistributionListSummaryItemContainer key={key} audienceId={this.props.audienceId} summaryItem={summaryItem} />;
			case AudienceSummaryItemType.AllReminders: {
				return summaryItem.value !== null && <SurveyAudienceSummaryItem {...this.props} key={key} summaryItems={summaryItem.value} />;
			}
			case AudienceSummaryItemType.Invite:
			case AudienceSummaryItemType.Reminder: {
				const emailSummaryItems: ISummaryItem[] = summaryItem.value as ISummaryItem[];
				return (
					emailSummaryItems.length > 0 && (
						<div key={key}>
							<Divider type='dashed' />
							{emailSummaryItems.map((subItem: ISummaryItem, subKey: number) => (
								<EmailSummaryItem key={subKey} {...subItem} />
							))}
						</div>
					)
				);
			}
			case AudienceSummaryItemType.IsTestAudience: {
				return (
					summaryItem.value === true && (
						<BannerDiv>
							<CustomBanner src={testFlag} left={0} top={0} />
						</BannerDiv>
					)
				);
			}
		}
	}
}
